import { FC } from 'react';
import Loader from 'react-loader-spinner';

import styles from './Button.module.css';

type Props = {
  title: any;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  bgColor?: string;
  color?: string;
  disabledColor?: string;
};

export const Button: FC<Props> = ({ title, onClick, disabled, loading, bgColor, color, disabledColor }) => {
  return (
    <button
      disabled={disabled || loading}
      className={`${styles.wrap} ${disabled && styles.disabled}`}
      onClick={onClick}
      style={{
        backgroundColor: disabledColor || bgColor || '#3ec8ae',
        color: color,
      }}
    >
      {loading ? <Loader type="ThreeDots" color="#fff" height={30} width={50} /> : title}
    </button>
  );
};
